import ZCheckbox from './checkbox.vue'

ZCheckbox.install = function(app) {
  app.component(ZCheckbox.name, ZCheckbox)
}

export default ZCheckbox